import React, { useEffect } from 'react'
import Navbar from '../Components/Navbar'
import Sidebar from '../Components/Sidebar'
import '../Layouts/Sidebarlayout.css'
import { connect } from 'react-redux'
import { sidebarOpen } from '../Services/Sidebar/action'
import { getFeatures, getModules, getPermissions } from '../Services/Authentication/action'

const Sidebarlayout = (props) => {
  const menuCollapse = props.menuCollapse;

  useEffect(() => {
    props.getModulesList();
    props.getFeaturesList();
    props.getPermissions(props?.user?.role_id);
  }, []);

  const menuIconClick = () => {
    props.sidebarOpen();
    props.getModulesList();
    props.getFeaturesList();
    props.getPermissions(props?.user?.role_id);
  };

  return (
    <div>
      <div className={`${menuCollapse ? "main sidebar-closed" : "main"}`}>
        <div className={`header-backdrop ${!menuCollapse ? 'body-overlay' : ''}`}
          onClick={menuIconClick}></div>
        <div className={`header ${menuCollapse ? "header-closed" : ""}`}>
          <Navbar />
        </div>
        <div className="sidebar">
          <Sidebar menuCollapse={menuCollapse} menuIconClick={menuIconClick} user={props.user} modules={props.modules} features={props.features} />
        </div>
        <div className={`content ${menuCollapse ? 'content-closed' : ''}`}>
          {props.children}
        </div>
      </div>
    </div>
  )
}

export const mapStateToProps = (state) => {
  return {
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    user: state.authenticationReducer.user,
    menuCollapse: state.sidebarReducer.isOpen,
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    permissions: state.authenticationReducer.permissions
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    sidebarOpen: () => {
      dispatch(sidebarOpen())
    },
    getModulesList: () => {
      dispatch(getModules());
    },
    getFeaturesList: () => {
      dispatch(getFeatures());
    },
    getPermissions: (id) => {
      dispatch(getPermissions(id));
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Sidebarlayout)
